module.exports = [{"value":"โรงเรียนมัธยม","text":"โรงเรียนมัธยม"},{"value":"วิทยาลัย/เทคนิค/เทคโนโลยี","text":"วิทยาลัย/เทคนิค/เทคโนโลยี"},{"value":"พณิชยการและบริหารธุรกิจ","text":"พณิชยการและบริหารธุรกิจ"},{"value":"ศูนย์การศึกษานอกระบบ","text":"ศูนย์การศึกษานอกระบบ"},{"value":"มหาวิทยาลัยรัฐบาล","text":"มหาวิทยาลัยรัฐบาล"},{"value":"มหาวิทยาลัยเอกชน","text":"มหาวิทยาลัยเอกชน"}]


//////////////////
// WEBPACK FOOTER
// ./src/assets/master/Education/educationGroup.json
// module id = 98C0
// module chunks = 2